const inputPhone = document.querySelectorAll('[name="phone"]');

const prefixNumber = (digit) => {
    if (digit === "7") return "7 (";
    if (digit === "8") return "8 (";
    if (digit === "9") return "7 (9";
    return "7 (";
};


inputPhone.forEach((el) => {
    el.addEventListener("input", () => {
        let value = el.value.replace(/\D+/g, "").slice(0, 11);
        let result = el.value.startsWith("+8") || el.value.startsWith("8") ? "" : "+";

        result += value[0] ? prefixNumber(value[0]) : "";

        const formatMap = { 4: ") ", 7: "-", 9: "-" };

        value.split("").forEach((char, index) => {
            if (formatMap[index]) result += formatMap[index];
            if (index > 0) result += char;
        });

        el.value = result;
    });
});
